import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const TenantRoutes: RouteBundle = {
  domain: 'tenant',
  routes: [
    {urlPattern: 'admin(/:section)', handler: EditorRoutes.tenantAdmin.bind(EditorRoutes), legacy: true},
  ],
};
